module.exports = __webpack_public_path__ + "static/media/NewLogo.d08811a6.png";